(function () {
  const root = document.querySelector("[data-kc-share-form]");
  if (!root) return;

  const apiBase = (root.dataset.apiBase || "").replace(/\/$/, "");
  const form = root.querySelector("form");
  const successEl = root.querySelector("[data-success]");
  const formErrorEl = root.querySelector("[data-form-error]");
  const fileErrorEl = root.querySelector("[data-file-error]");
  const fileInput = root.querySelector("[data-file-input]");
  const thumbs = root.querySelector("[data-thumbs]");
  const productField = root.querySelector("[data-product-field]");
  const productHandleInput = root.querySelector("[data-product-handle]");
  const productSearchInput = root.querySelector("[data-product-search]");
  const productList = root.querySelector("[data-product-list]");
  const countrySelect = root.querySelector("[data-country-select]");
  const countryOtherWrap = root.querySelector("[data-country-other-wrap]");
  const countryOtherInput = root.querySelector("[data-country-other]");
  const submitBtn = root.querySelector("[data-submit]");
  const titleInput = root.querySelector("#kc-share-title");
  const descInput = root.querySelector("#kc-share-description");
  const titleCount = root.querySelector("[data-title-count]");
  const descCount = root.querySelector("[data-desc-count]");

  let selectedFiles = [];
  let productResults = [];
  let productSearchTimer = null;
  let productSearchSeq = 0;
  let activeOptionIndex = -1;

  function syncCountryOther() {
    if (!countrySelect || !countryOtherWrap || !countryOtherInput) return;
    const isOther = countrySelect.value === "Other";
    countryOtherWrap.hidden = !isOther;
    countryOtherInput.disabled = !isOther;
    if (!isOther) countryOtherInput.value = "";
  }

  function countryRegionValue() {
    if (!countrySelect) return "";
    if (countrySelect.value === "Other") {
      return String(countryOtherInput?.value || "").trim();
    }
    return String(countrySelect.value || "").trim();
  }

  function qs(name) {
    return new URLSearchParams(window.location.search).get(name) || "";
  }

  function setInvalid(field, message) {
    if (!field) return;
    field.classList.add("is-invalid");
    const err = field.querySelector(".kc-share__error");
    if (err && message) err.textContent = message;
  }

  function clearInvalid() {
    root.querySelectorAll(".kc-share__field.is-invalid").forEach((el) => el.classList.remove("is-invalid"));
    const consentErr = root.querySelector("[data-consent-error]");
    if (consentErr) consentErr.style.display = "none";
    if (formErrorEl) formErrorEl.classList.remove("is-visible");
    if (fileErrorEl) {
      fileErrorEl.classList.remove("is-visible");
      fileErrorEl.textContent = "";
    }
  }

  function showFileError(text) {
    if (!fileErrorEl) return;
    fileErrorEl.textContent = text;
    fileErrorEl.classList.add("is-visible");
  }

  function renderThumbs() {
    if (!thumbs) return;
    thumbs.innerHTML = "";
    selectedFiles.forEach((file, index) => {
      const pill = document.createElement("div");
      pill.className = "kc-share__pill";
      pill.innerHTML = `<span></span><button type="button" aria-label="Remove">×</button>`;
      pill.querySelector("span").textContent = file.name;
      pill.querySelector("button").addEventListener("click", () => {
        selectedFiles.splice(index, 1);
        renderThumbs();
      });
      thumbs.appendChild(pill);
    });
  }

  function takeFiles(fileList) {
    showFileError("");
    fileErrorEl?.classList.remove("is-visible");
    const incoming = Array.from(fileList || []);
    const next = selectedFiles.slice();
    for (const f of incoming) {
      if (next.length >= 3) {
        showFileError("You can upload up to 3 images. Remove a file and try again.");
        break;
      }
      if (!["image/jpeg", "image/png", "image/webp"].includes(f.type)) {
        showFileError("This file type isn’t supported. Please upload a JPG, PNG, or WebP image.");
        continue;
      }
      if (f.size > 5 * 1024 * 1024) {
        showFileError("This image is larger than 5 MB. Please choose a smaller file.");
        continue;
      }
      next.push(f);
    }
    selectedFiles = next;
    renderThumbs();
  }

  function setProductSelection(product) {
    if (!productHandleInput || !productSearchInput) return;
    if (!product) {
      productHandleInput.value = "";
      return;
    }
    productHandleInput.value = product.handle || "";
    productSearchInput.value = product.title || product.handle || "";
  }

  function closeProductList() {
    if (!productList || !productSearchInput) return;
    productList.hidden = true;
    productList.innerHTML = "";
    productSearchInput.setAttribute("aria-expanded", "false");
    activeOptionIndex = -1;
  }

  function openProductList() {
    if (!productList || !productSearchInput || !productResults.length) {
      closeProductList();
      return;
    }
    productList.hidden = false;
    productSearchInput.setAttribute("aria-expanded", "true");
  }

  function renderProductResults(products) {
    productResults = products || [];
    if (!productList) return;
    productList.innerHTML = "";
    if (!productResults.length) {
      closeProductList();
      return;
    }
    productResults.forEach((p, index) => {
      const li = document.createElement("li");
      li.className = "kc-share__combo-option";
      li.id = `kc-share-product-opt-${index}`;
      li.setAttribute("role", "option");
      li.setAttribute("data-index", String(index));
      li.textContent = p.title || p.handle;
      li.addEventListener("mousedown", (e) => {
        e.preventDefault();
        setProductSelection(p);
        closeProductList();
      });
      productList.appendChild(li);
    });
    openProductList();
  }

  function highlightProductOption(index) {
    if (!productList) return;
    const options = Array.from(productList.querySelectorAll('[role="option"]'));
    options.forEach((el) => el.removeAttribute("aria-selected"));
    if (index < 0 || index >= options.length) {
      activeOptionIndex = -1;
      productSearchInput?.removeAttribute("aria-activedescendant");
      return;
    }
    activeOptionIndex = index;
    const el = options[index];
    el.setAttribute("aria-selected", "true");
    productSearchInput?.setAttribute("aria-activedescendant", el.id);
    el.scrollIntoView({ block: "nearest" });
  }

  async function fetchProducts(params) {
    if (!apiBase) return [];
    const url = new URL(`${apiBase}/api/products`);
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v) url.searchParams.set(k, v);
    });
    const resp = await fetch(url.toString(), {
      credentials: "omit",
      headers: { Accept: "application/json" },
    });
    if (!resp.ok) throw new Error("products");
    const data = await resp.json();
    return Array.isArray(data.products) ? data.products : [];
  }

  async function searchProductsByTitle(query) {
    const q = String(query || "").trim();
    if (!q) {
      renderProductResults([]);
      return;
    }
    const seq = ++productSearchSeq;
    try {
      const products = await fetchProducts({ q });
      if (seq !== productSearchSeq) return;
      renderProductResults(products);
    } catch (_err) {
      if (seq !== productSearchSeq) return;
      renderProductResults([]);
    }
  }

  async function preselectProductFromQuery() {
    const handle = qs("product").trim();
    if (!handle || !productHandleInput) return;
    try {
      const products = await fetchProducts({ handle });
      if (products[0]) setProductSelection(products[0]);
    } catch (_err) {
      // Leave empty; user can search by title.
    }
  }

  function scheduleProductSearch(query) {
    clearTimeout(productSearchTimer);
    productSearchTimer = setTimeout(() => {
      searchProductsByTitle(query);
    }, 280);
  }

  function validate() {
    clearInvalid();
    let ok = true;

    const requiredIds = [
      ["kc-share-display-name", "This field is required."],
      ["kc-share-email", "Please enter a valid email address."],
      ["kc-share-title", "This field is required."],
      ["kc-share-description", "This field is required."],
      ["kc-share-language", "This field is required."],
    ];

    requiredIds.forEach(([id, msg]) => {
      const el = root.querySelector("#" + id);
      const field = el?.closest(".kc-share__field");
      let valid = Boolean(el && String(el.value || "").trim());
      if (id === "kc-share-email") {
        valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(el?.value || "").trim());
      }
      if (!valid) {
        ok = false;
        setInvalid(field, msg);
      }
    });

    if (!String(productHandleInput?.value || "").trim()) {
      ok = false;
      setInvalid(productField, "Please select a product from the search results.");
    }

    const video = root.querySelector("#kc-share-video");
    const article = root.querySelector("#kc-share-article");
    const v = String(video?.value || "").trim();
    const a = String(article?.value || "").trim();
    if (!v && !a) {
      ok = false;
      setInvalid(video?.closest(".kc-share__field"), "Please add at least one video or article link.");
    }
    [video, article].forEach((el) => {
      const val = String(el?.value || "").trim();
      if (val && !/^https?:\/\//i.test(val)) {
        ok = false;
        setInvalid(el.closest(".kc-share__field"), "Please enter a valid URL.");
      }
    });

    const consent = root.querySelector("#kc-share-consent");
    if (!consent?.checked) {
      ok = false;
      const consentErr = root.querySelector("[data-consent-error]");
      if (consentErr) consentErr.style.display = "block";
    }

    if (!ok && formErrorEl) formErrorEl.classList.add("is-visible");
    return ok;
  }

  function setSubmitting(on) {
    if (!submitBtn) return;
    submitBtn.disabled = on;
    submitBtn.innerHTML = on
      ? "<span>Submitting…</span>"
      : '<span>Submit your setup</span><span aria-hidden="true">→</span>';
    form.querySelectorAll("input, textarea, select, button").forEach((el) => {
      if (el === submitBtn) return;
      if (el.type === "file") return;
      el.disabled = on;
    });
  }

  titleInput?.addEventListener("input", () => {
    if (titleCount) titleCount.textContent = String(titleInput.value.length);
  });
  descInput?.addEventListener("input", () => {
    if (descCount) descCount.textContent = String(descInput.value.length);
  });

  root.querySelector("[data-browse]")?.addEventListener("click", () => fileInput?.click());
  fileInput?.addEventListener("change", () => takeFiles(fileInput.files));

  const dropZone = root.querySelector("[data-dropzone]");
  dropZone?.addEventListener("dragover", (e) => {
    e.preventDefault();
  });
  dropZone?.addEventListener("drop", (e) => {
    e.preventDefault();
    takeFiles(e.dataTransfer?.files);
  });

  productSearchInput?.addEventListener("input", () => {
    // Typing means user is changing selection — clear committed handle until they pick a result.
    if (productHandleInput) productHandleInput.value = "";
    scheduleProductSearch(productSearchInput.value);
  });

  productSearchInput?.addEventListener("keydown", (e) => {
    if (productList?.hidden && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
      scheduleProductSearch(productSearchInput.value);
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      highlightProductOption(Math.min(activeOptionIndex + 1, productResults.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      highlightProductOption(Math.max(activeOptionIndex - 1, 0));
    } else if (e.key === "Enter") {
      if (!productList?.hidden && activeOptionIndex >= 0 && productResults[activeOptionIndex]) {
        e.preventDefault();
        setProductSelection(productResults[activeOptionIndex]);
        closeProductList();
      }
    } else if (e.key === "Escape") {
      closeProductList();
    }
  });

  productSearchInput?.addEventListener("blur", () => {
    setTimeout(closeProductList, 120);
  });

  form?.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (!validate()) return;
    if (!apiBase) {
      if (formErrorEl) {
        formErrorEl.textContent = "Submission API is not configured.";
        formErrorEl.classList.add("is-visible");
      }
      return;
    }

    setSubmitting(true);
    successEl?.classList.remove("is-visible");

    const fd = new FormData();
    fd.append("display_name", root.querySelector("#kc-share-display-name").value.trim());
    fd.append("email", root.querySelector("#kc-share-email").value.trim());
    fd.append("country_region", countryRegionValue());
    fd.append("product", productHandleInput.value.trim());
    fd.append("title", titleInput.value.trim());
    fd.append("description", descInput.value.trim());
    fd.append("video_url", root.querySelector("#kc-share-video").value.trim());
    fd.append("article_url", root.querySelector("#kc-share-article").value.trim());
    fd.append("settings", root.querySelector("#kc-share-settings")?.value.trim() || "");
    fd.append("content_language", root.querySelector("#kc-share-language").value);
    fd.append("consent", root.querySelector("#kc-share-consent").checked ? "true" : "false");
    fd.append(
      "marketing_opt_in",
      root.querySelector("#kc-share-marketing")?.checked ? "true" : "false",
    );

    const turnstile = root.querySelector("[name='cf-turnstile-response']");
    if (turnstile?.value) fd.append("cf_turnstile_response", turnstile.value);

    selectedFiles.forEach((f) => fd.append("photos", f, f.name));

    try {
      const resp = await fetch(`${apiBase}/api/submissions`, {
        method: "POST",
        body: fd,
        credentials: "omit",
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) {
        if (data.errors) {
          Object.entries(data.errors).forEach(([key, message]) => {
            if (key === "photos") showFileError(message);
            else if (key === "consent") {
              const consentErr = root.querySelector("[data-consent-error]");
              if (consentErr) {
                consentErr.style.display = "block";
                consentErr.textContent = message;
              }
            } else if (key === "product") {
              setInvalid(productField, message);
            } else {
              const map = {
                display_name: "kc-share-display-name",
                email: "kc-share-email",
                title: "kc-share-title",
                description: "kc-share-description",
                video_url: "kc-share-video",
                article_url: "kc-share-article",
                content_language: "kc-share-language",
              };
              const el = root.querySelector("#" + (map[key] || ""));
              setInvalid(el?.closest(".kc-share__field"), message);
            }
          });
          formErrorEl?.classList.add("is-visible");
        } else if (formErrorEl) {
          formErrorEl.textContent = data.message || "Something went wrong. Please try again.";
          formErrorEl.classList.add("is-visible");
        }
        return;
      }

      form.reset();
      setProductSelection(null);
      if (productSearchInput) productSearchInput.value = "";
      closeProductList();
      selectedFiles = [];
      renderThumbs();
      if (titleCount) titleCount.textContent = "0";
      if (descCount) descCount.textContent = "0";
      syncCountryOther();
      successEl?.classList.add("is-visible");
      successEl?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    } catch (_err) {
      if (formErrorEl) {
        formErrorEl.textContent = "Something went wrong. Please try again.";
        formErrorEl.classList.add("is-visible");
      }
    } finally {
      setSubmitting(false);
    }
  });

  countrySelect?.addEventListener("change", syncCountryOther);
  syncCountryOther();
  preselectProductFromQuery();
})();
